import React from 'react';

const POINTS = [
  { key: 'midline', label: 'Midline', color: 'bg-blue-500', description: 'Facial midline center' },
  { key: 'leftCommissure', label: 'Left Commissure', color: 'bg-green-500', description: 'Left lip corner' },
  { key: 'rightCommissure', label: 'Right Commissure', color: 'bg-green-500', description: 'Right lip corner' },
  { key: 'incisalEdge', label: 'Incisal Edge', color: 'bg-red-500', description: 'Incisal edge position' },
];

const ReferencePointsPanel = ({ referencePoints, placingPoint, onStartPlacing, onClearPoint }) => {
  const placedCount = Object.values(referencePoints).filter(Boolean).length;

  return (
    <div>
      <h3 className="text-sm font-bold text-gray-800 mb-3">Reference Points</h3>
      <p className="text-xs text-gray-500 mb-3">
        Place points on the photo to guide tooth positioning. Click a button then click on the photo.
      </p>

      <div className="space-y-2">
        {POINTS.map(point => {
          const isPlaced = !!referencePoints[point.key];
          const isPlacing = placingPoint === point.key;

          return (
            <div
              key={point.key}
              className={`flex items-center justify-between p-2.5 rounded-lg border transition ${
                isPlacing
                  ? 'border-blue-400 bg-blue-50'
                  : isPlaced
                  ? 'border-green-200 bg-green-50'
                  : 'border-gray-200 bg-white'
              }`}
            >
              <div className="flex items-center gap-2">
                <div className={`w-3 h-3 rounded-full ${point.color} ${isPlaced ? '' : 'opacity-30'}`} />
                <div>
                  <div className="text-xs font-medium text-gray-800">{point.label}</div>
                  {isPlaced && referencePoints[point.key] && (
                    <div className="text-[10px] text-gray-400">
                      ({Math.round(referencePoints[point.key].x)}, {Math.round(referencePoints[point.key].y)})
                    </div>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-1">
                {isPlaced && (
                  <button
                    onClick={() => onClearPoint(point.key)}
                    className="text-[10px] text-red-400 hover:text-red-600 px-1"
                  >
                    Clear
                  </button>
                )}
                <button
                  onClick={() => onStartPlacing(point.key)}
                  className={`px-2.5 py-1 text-[11px] font-medium rounded-md transition ${
                    isPlacing
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                  }`}
                >
                  {isPlacing ? 'Placing...' : isPlaced ? 'Move' : 'Place'}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-3 flex items-center justify-between text-xs text-gray-500">
        <span>{placedCount}/4 placed</span>
        {placedCount > 0 && (
          <button
            onClick={() => POINTS.forEach(p => onClearPoint(p.key))}
            className="text-red-400 hover:text-red-600"
          >
            Clear All
          </button>
        )}
      </div>
    </div>
  );
};

export default ReferencePointsPanel;
